// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/common/v1/imageprocessor/v1/types.proto (package creativefabrica.common.v1.imageprocessor.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { PaginationRequest, PaginationRequestJson, PaginationResponse, PaginationResponseJson } from "../../types_pb";
import { file_creativefabrica_common_v1_types } from "../../types_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/common/v1/imageprocessor/v1/types.proto.
 */
export const file_creativefabrica_common_v1_imageprocessor_v1_types: GenFile = /*@__PURE__*/
  fileDesc("CjdjcmVhdGl2ZWZhYnJpY2EvY29tbW9uL3YxL2ltYWdlcHJvY2Vzc29yL3YxL3R5cGVzLnByb3RvEitjcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLmltYWdlcHJvY2Vzc29yLnYxIqwCCgdTZXNzaW9uEgoKAmlkGAEgASgJEg8KB3VzZXJfaWQYAiABKAkSSgoGc3RhdHVzGAMgASgOMjouY3JlYXRpdmVmYWJyaWNhLmNvbW1vbi52MS5pbWFnZXByb2Nlc3Nvci52MS5TZXNzaW9uU3RhdHVzEg4KBmltYWdlcxgEIAEoDRIuCgpjcmVhdGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIwCgxyZXF1ZXN0ZWRfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi8KC2ZpbmlzaGVkX2F0GAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIVCg10aHVtYm5haWxfdXJsGAggASgJIrMBCghEb3dubG9hZBIKCgJpZBgBIAEoCRIPCgd1c2VyX2lkGAIgASgJEksKBnN0YXR1cxgDIAEoDjI7LmNyZWF0aXZlZmFicmljYS5jb21tb24udjEuaW1hZ2Vwcm9jZXNzb3IudjEuRG93bmxvYWRTdGF0dXMSCwoDdXJsGAQgASgJEjAKDHJlcXVlc3RlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAihQMKBUltYWdlEgoKAmlkGAEgASgJEg8KB3VzZXJfaWQYAiABKAkSFAoMb3JpZ2luYWxfdXJsGAMgASgJEhQKDHJlc3BvbnNlX3VybBgEIAEoCRIRCglmaWxlX25hbWUYBSABKAkSFQoNdGh1bWJuYWlsX3VybBgGIAEoCRJICgZzdGF0dXMYByABKA4yOC5jcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLmltYWdlcHJvY2Vzc29yLnYxLkltYWdlU3RhdHVzEhUKDWVycm9yX21lc3NhZ2UYCCABKAkSMAoMcmVxdWVzdGVkX2F0GAkgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIvCgtyZWNlaXZlZF9hdBgKIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEgoKc2Vzc2lvbl9pZBgLIAEoCRITCgtwcmV2aWV3X3VybBgMIAEoCRIcChRvcmlnaW5hbF9wcmV2aWV3X3VybBgNIAEoCSI7ChNCYXRjaFVybFJlcXVlc3RJdGVtEhEKCWZpbGVfbmFtZRgBIAEoCRIRCglmaWxlX3NpemUYAiABKAMiNgoUQmF0Y2hVcmxSZXNwb25zZUl0ZW0SEQoJdXBsb2FkX2lkGAEgASgJEgsKA3VybBgCIAEoCSI5ChRQdWJsaXNoSW1hZ2VSZXNwb25zZRIQCghpbWFnZV9pZBgBIAEoCRIPCgdzdWNjZXNzGAIgASgIIkkKG01pZ3JhdGVBbm9ueW1vdXNVc2VyUmVxdWVzdBIZChFhbm9ueW1vdXNfdXNlcl9pZBgBIAEoCRIPCgd1c2VyX2lkGAIgASgJIh4KHE1pZ3JhdGVBbm9ueW1vdXNVc2VyUmVzcG9uc2UiaAoQR2V0SW1hZ2VzUmVxdWVzdBISCgpzZXNzaW9uX2lkGAEgASgJEkAKCnBhZ2luYXRpb24YBCABKAsyLC5jcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLlBhZ2luYXRpb25SZXF1ZXN0IpoBChFHZXRJbWFnZXNSZXNwb25zZRJCCgZpbWFnZXMYASADKAsyMi5jcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLmltYWdlcHJvY2Vzc29yLnYxLkltYWdlEkEKCnBhZ2luYXRpb24YAyABKAsyLS5jcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLlBhZ2luYXRpb25SZXNwb25zZSJhCg9Jbml0aWF0ZVJlcXVlc3QSTgoEdXJscxgBIAMoCzJALmNyZWF0aXZlZmFicmljYS5jb21tb24udjEuaW1hZ2Vwcm9jZXNzb3IudjEuQmF0Y2hVcmxSZXF1ZXN0SXRlbSKqAQoQSW5pdGlhdGVSZXNwb25zZRJFCgdzZXNzaW9uGAEgASgLMjQuY3JlYXRpdmVmYWJyaWNhLmNvbW1vbi52MS5pbWFnZXByb2Nlc3Nvci52MS5TZXNzaW9uEk8KBHVybHMYAiADKAsyQS5jcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLmltYWdlcHJvY2Vzc29yLnYxLkJhdGNoVXJsUmVzcG9uc2VJdGVtIrABChVQdWJsaXNoU2Vzc2lvblJlcXVlc3QSFAoKc2Vzc2lvbl9pZBgBIAEoCUgAEl4KCWltYWdlX2lkcxgCIAEoCzJJLmNyZWF0aXZlZmFicmljYS5jb21tb24udjEuaW1hZ2Vwcm9jZXNzb3IudjEuUHVibGlzaFNlc3Npb25SZXF1ZXN0LkltYWdlc0gAGhoKBkltYWdlcxIQCghpbWFnZV9pZBgBIAMoCUIFCgNpZHMiawoWUHVibGlzaFNlc3Npb25SZXNwb25zZRJRCgZpbWFnZXMYASADKAsyQS5jcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLmltYWdlcHJvY2Vzc29yLnYxLlB1Ymxpc2hJbWFnZVJlc3BvbnNlIk8KC0xpc3RSZXF1ZXN0EkAKCnBhZ2luYXRpb24YBCABKAsyLC5jcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLlBhZ2luYXRpb25SZXF1ZXN0IpkBCgxMaXN0UmVzcG9uc2USRgoIc2Vzc2lvbnMYASADKAsyNC5jcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLmltYWdlcHJvY2Vzc29yLnYxLlNlc3Npb24SQQoKcGFnaW5hdGlvbhgCIAEoCzItLmNyZWF0aXZlZmFicmljYS5jb21tb24udjEuUGFnaW5hdGlvblJlc3BvbnNlIiAKCkdldFJlcXVlc3QSEgoKc2Vzc2lvbl9pZBgBIAEoCSJUCgtHZXRSZXNwb25zZRJFCgdzZXNzaW9uGAEgASgLMjQuY3JlYXRpdmVmYWJyaWNhLmNvbW1vbi52MS5pbWFnZXByb2Nlc3Nvci52MS5TZXNzaW9uIq4BCg9Eb3dubG9hZFJlcXVlc3QSFAoKc2Vzc2lvbl9pZBgBIAEoCUgAEloKCWltYWdlX2lkcxgCIAEoCzJFLmNyZWF0aXZlZmFicmljYS5jb21tb24udjEuaW1hZ2Vwcm9jZXNzb3IudjEuRG93bmxvYWRSZXF1ZXN0LkltYWdlSWRzSAAaHQoISW1hZ2VJZHMSEQoJaW1hZ2VfaWRzGAEgAygJQgoKCGRvd25sb2FkIicKEERvd25sb2FkUmVzcG9uc2USEwoLZG93bmxvYWRfaWQYASABKAkiKQoSR2V0RG93bmxvYWRSZXF1ZXN0EhMKC2Rvd25sb2FkX2lkGAEgASgJIl4KE0dldERvd25sb2FkUmVzcG9uc2USRwoIZG93bmxvYWQYASABKAsyNS5jcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLmltYWdlcHJvY2Vzc29yLnYxLkRvd25sb2FkIroBChxPblByb2Nlc3NpbmdDb21wbGV0ZWRSZXF1ZXN0EgoKAmlkGAEgASgJEhQKDHJlc3BvbnNlX3VybBgCIAEoCRIVCg10aHVtYm5haWxfdXJsGAMgASgJEhUKDWVycm9yX21lc3NhZ2UYBCABKAkSSgoKZXJyb3JfY29kZRgFIAEoDjI2LmNyZWF0aXZlZmFicmljYS5jb21tb24udjEuaW1hZ2Vwcm9jZXNzb3IudjEuRXJyb3JDb2RlIh8KHU9uUHJvY2Vzc2luZ0NvbXBsZXRlZFJlc3BvbnNlIi0KFkRvd25sb2FkUHJvY2Vzc1JlcXVlc3QSEwoLZG93bmxvYWRfaWQYASABKAkiGQoXRG93bmxvYWRQcm9jZXNzUmVzcG9uc2UiIwoNRGVsZXRlUmVxdWVzdBISCgpzZXNzaW9uX2lkGAEgASgJIhAKDkRlbGV0ZVJlc3BvbnNlIhIKEERlbGV0ZUFsbFJlcXVlc3QiEwoRRGVsZXRlQWxsUmVzcG9uc2UiIgoOUHVibGlzaFJlcXVlc3QSEAoIaW1hZ2VfaWQYASABKAkiEQoPUHVibGlzaFJlc3BvbnNlIucBChhPblVwbG9hZENvbXBsZXRlZFJlcXVlc3QSDwoHdXNlcl9pZBgBIAEoCRIRCgl1cGxvYWRfaWQYAiABKAkSCwoDdXJsGAMgASgJEhEKCWZpbGVfbmFtZRgFIAEoCRIRCglmaWxlX3NpemUYBiABKAMSSQoGc3RhdHVzGAQgASgOMjkuY3JlYXRpdmVmYWJyaWNhLmNvbW1vbi52MS5pbWFnZXByb2Nlc3Nvci52MS5VcGxvYWRTdGF0dXMSFQoNZXJyb3JfbWVzc2FnZRgHIAEoCRISCgpzZXNzaW9uX2lkGAggASgJIhsKGU9uVXBsb2FkQ29tcGxldGVkUmVzcG9uc2UiUwoOSW1hZ2VQcm9jZXNzZWQSQQoFaW1hZ2UYASABKAsyMi5jcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLmltYWdlcHJvY2Vzc29yLnYxLkltYWdlIlkKEFNlc3Npb25Db21wbGV0ZWQSRQoHc2Vzc2lvbhgBIAEoCzI0LmNyZWF0aXZlZmFicmljYS5jb21tb24udjEuaW1hZ2Vwcm9jZXNzb3IudjEuU2Vzc2lvbiJcChFEb3dubG9hZENvbXBsZXRlZBJHCghkb3dubG9hZBgBIAEoCzI1LmNyZWF0aXZlZmFicmljYS5jb21tb24udjEuaW1hZ2Vwcm9jZXNzb3IudjEuRG93bmxvYWQiKQoTSW1hZ2VQcm9jZXNzZWRFdmVudBISCgpzZXNzaW9uX2lkGAEgASgJIisKFVNlc3Npb25Db21wbGV0ZWRFdmVudBISCgpzZXNzaW9uX2lkGAEgASgJIhgKFlNlc3Npb25zQ29tcGxldGVkRXZlbnQiLQoWRG93bmxvYWRDb21wbGV0ZWRFdmVudBITCgtkb3dubG9hZF9pZBgBIAEoCSIZChdEb3dubG9hZHNDb21wbGV0ZWRFdmVudCqWAQoLSW1hZ2VTdGF0dXMSHAoYSU1BR0VfU1RBVFVTX1VOU1BFQ0lGSUVEEAASGQoVSU1BR0VfU1RBVFVTX1VQTE9BREVEEAESGgoWSU1BR0VfU1RBVFVTX1JFUVVFU1RFRBACEhoKFklNQUdFX1NUQVRVU19DT01QTEVURUQQAxIWChJJTUFHRV9TVEFUVVNfRVJST1IQBCqKAQoORG93bmxvYWRTdGF0dXMSHwobRE9XTkxPQURfU1RBVFVTX1VOU1BFQ0lGSUVEEAASHQoZRE9XTkxPQURfU1RBVFVTX1JFUVVFU1RFRBABEh0KGURPV05MT0FEX1NUQVRVU19DT01QTEVURUQQAhIZChVET1dOTE9BRF9TVEFUVVNfRVJST1IQAyqiAQoNU2Vzc2lvblN0YXR1cxIeChpTRVNTSU9OX1NUQVRVU19VTlNQRUNJRklFRBAAEhoKFlNFU1NJT05fU1RBVFVTX0NSRUFURUQQARIcChhTRVNTSU9OX1NUQVRVU19SRVFVRVNURUQQAhIcChhTRVNTSU9OX1NUQVRVU19DT01QTEVURUQQAxIZChVTRVNTSU9OX1NUQVRVU19GQUlMRUQQBCp8CgxVcGxvYWRTdGF0dXMSHQoZVVBMT0FEX1NUQVRVU19VTlNQRUNJRklFRBAAEhkKFVVQTE9BRF9TVEFUVVNfUEVORElORxABEhkKFVVQTE9BRF9TVEFUVVNfU1VDQ0VTUxACEhcKE1VQTE9BRF9TVEFUVVNfRVJST1IQAyqeAQoJRXJyb3JDb2RlEhoKFkVSUk9SX0NPREVfVU5TUEVDSUZJRUQQABIWChJFUlJPUl9DT0RFX1RJTUVPVVQQARIYChRFUlJPUl9DT0RFX1NBSV9FUlJPUhACEiQKIEVSUk9SX0NPREVfSU5URVJOQUxfU0VSVkVSX0VSUk9SEAMSHQoZRVJST1JfQ09ERV9VUExPQURfRVhQSVJFRBAEQmlaZ2dpdGh1Yi5jb20vY3JlYXRpdmVmYWJyaWNhL3NjaGVtYXMvcGtnL2dlbi9jcmVhdGl2ZWZhYnJpY2EvY29tbW9uL3YxL2ltYWdlcHJvY2Vzc29yL3YxO2ltYWdlcHJvY2Vzc29ydjFiBnByb3RvMw", [file_creativefabrica_common_v1_types, file_google_protobuf_timestamp]);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.Session
 */
export type Session = Message<"creativefabrica.common.v1.imageprocessor.v1.Session"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.SessionStatus status = 3;
   */
  status: SessionStatus;

  /**
   * @generated from field: uint32 images = 4;
   */
  images: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 6;
   */
  requestedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 7;
   */
  finishedAt?: Timestamp | undefined;

  /**
   * @generated from field: string thumbnail_url = 8;
   */
  thumbnailUrl: string;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.Session
 */
export type SessionJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.SessionStatus status = 3;
   */
  status?: SessionStatusJson;

  /**
   * @generated from field: uint32 images = 4;
   */
  images?: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 6;
   */
  requestedAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 7;
   */
  finishedAt?: TimestampJson;

  /**
   * @generated from field: string thumbnail_url = 8;
   */
  thumbnailUrl?: string;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.Session.
 * Use `create(SessionSchema)` to create a new message.
 */
export const SessionSchema: GenMessage<Session, {jsonType: SessionJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 0);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.Download
 */
export type Download = Message<"creativefabrica.common.v1.imageprocessor.v1.Download"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.DownloadStatus status = 3;
   */
  status: DownloadStatus;

  /**
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 5;
   */
  requestedAt?: Timestamp | undefined;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.Download
 */
export type DownloadJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.DownloadStatus status = 3;
   */
  status?: DownloadStatusJson;

  /**
   * @generated from field: string url = 4;
   */
  url?: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 5;
   */
  requestedAt?: TimestampJson;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.Download.
 * Use `create(DownloadSchema)` to create a new message.
 */
export const DownloadSchema: GenMessage<Download, {jsonType: DownloadJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 1);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.Image
 */
export type Image = Message<"creativefabrica.common.v1.imageprocessor.v1.Image"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string original_url = 3;
   */
  originalUrl: string;

  /**
   * @generated from field: string response_url = 4;
   */
  responseUrl: string;

  /**
   * @generated from field: string file_name = 5;
   */
  fileName: string;

  /**
   * @generated from field: string thumbnail_url = 6;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.ImageStatus status = 7;
   */
  status: ImageStatus;

  /**
   * @generated from field: string error_message = 8;
   */
  errorMessage: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 9;
   */
  requestedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp received_at = 10;
   */
  receivedAt?: Timestamp | undefined;

  /**
   * @generated from field: string session_id = 11;
   */
  sessionId: string;

  /**
   * @generated from field: string preview_url = 12;
   */
  previewUrl: string;

  /**
   * @generated from field: string original_preview_url = 13;
   */
  originalPreviewUrl: string;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.Image
 */
export type ImageJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string original_url = 3;
   */
  originalUrl?: string;

  /**
   * @generated from field: string response_url = 4;
   */
  responseUrl?: string;

  /**
   * @generated from field: string file_name = 5;
   */
  fileName?: string;

  /**
   * @generated from field: string thumbnail_url = 6;
   */
  thumbnailUrl?: string;

  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.ImageStatus status = 7;
   */
  status?: ImageStatusJson;

  /**
   * @generated from field: string error_message = 8;
   */
  errorMessage?: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 9;
   */
  requestedAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp received_at = 10;
   */
  receivedAt?: TimestampJson;

  /**
   * @generated from field: string session_id = 11;
   */
  sessionId?: string;

  /**
   * @generated from field: string preview_url = 12;
   */
  previewUrl?: string;

  /**
   * @generated from field: string original_preview_url = 13;
   */
  originalPreviewUrl?: string;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.Image.
 * Use `create(ImageSchema)` to create a new message.
 */
export const ImageSchema: GenMessage<Image, {jsonType: ImageJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 2);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.BatchUrlRequestItem
 */
export type BatchUrlRequestItem = Message<"creativefabrica.common.v1.imageprocessor.v1.BatchUrlRequestItem"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize: bigint;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.BatchUrlRequestItem
 */
export type BatchUrlRequestItemJson = {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName?: string;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize?: string;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.BatchUrlRequestItem.
 * Use `create(BatchUrlRequestItemSchema)` to create a new message.
 */
export const BatchUrlRequestItemSchema: GenMessage<BatchUrlRequestItem, {jsonType: BatchUrlRequestItemJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 3);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.BatchUrlResponseItem
 */
export type BatchUrlResponseItem = Message<"creativefabrica.common.v1.imageprocessor.v1.BatchUrlResponseItem"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.BatchUrlResponseItem
 */
export type BatchUrlResponseItemJson = {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId?: string;

  /**
   * @generated from field: string url = 2;
   */
  url?: string;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.BatchUrlResponseItem.
 * Use `create(BatchUrlResponseItemSchema)` to create a new message.
 */
export const BatchUrlResponseItemSchema: GenMessage<BatchUrlResponseItem, {jsonType: BatchUrlResponseItemJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 4);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.PublishImageResponse
 */
export type PublishImageResponse = Message<"creativefabrica.common.v1.imageprocessor.v1.PublishImageResponse"> & {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId: string;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.PublishImageResponse
 */
export type PublishImageResponseJson = {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId?: string;

  /**
   * @generated from field: bool success = 2;
   */
  success?: boolean;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.PublishImageResponse.
 * Use `create(PublishImageResponseSchema)` to create a new message.
 */
export const PublishImageResponseSchema: GenMessage<PublishImageResponse, {jsonType: PublishImageResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 5);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.MigrateAnonymousUserRequest
 */
export type MigrateAnonymousUserRequest = Message<"creativefabrica.common.v1.imageprocessor.v1.MigrateAnonymousUserRequest"> & {
  /**
   * @generated from field: string anonymous_user_id = 1;
   */
  anonymousUserId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.MigrateAnonymousUserRequest
 */
export type MigrateAnonymousUserRequestJson = {
  /**
   * @generated from field: string anonymous_user_id = 1;
   */
  anonymousUserId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.MigrateAnonymousUserRequest.
 * Use `create(MigrateAnonymousUserRequestSchema)` to create a new message.
 */
export const MigrateAnonymousUserRequestSchema: GenMessage<MigrateAnonymousUserRequest, {jsonType: MigrateAnonymousUserRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 6);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.MigrateAnonymousUserResponse
 */
export type MigrateAnonymousUserResponse = Message<"creativefabrica.common.v1.imageprocessor.v1.MigrateAnonymousUserResponse"> & {
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.MigrateAnonymousUserResponse
 */
export type MigrateAnonymousUserResponseJson = {
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.MigrateAnonymousUserResponse.
 * Use `create(MigrateAnonymousUserResponseSchema)` to create a new message.
 */
export const MigrateAnonymousUserResponseSchema: GenMessage<MigrateAnonymousUserResponse, {jsonType: MigrateAnonymousUserResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 7);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.GetImagesRequest
 */
export type GetImagesRequest = Message<"creativefabrica.common.v1.imageprocessor.v1.GetImagesRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 4;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.GetImagesRequest
 */
export type GetImagesRequestJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 4;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.GetImagesRequest.
 * Use `create(GetImagesRequestSchema)` to create a new message.
 */
export const GetImagesRequestSchema: GenMessage<GetImagesRequest, {jsonType: GetImagesRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 8);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.GetImagesResponse
 */
export type GetImagesResponse = Message<"creativefabrica.common.v1.imageprocessor.v1.GetImagesResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.common.v1.imageprocessor.v1.Image images = 1;
   */
  images: Image[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 3;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.GetImagesResponse
 */
export type GetImagesResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.common.v1.imageprocessor.v1.Image images = 1;
   */
  images?: ImageJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 3;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.GetImagesResponse.
 * Use `create(GetImagesResponseSchema)` to create a new message.
 */
export const GetImagesResponseSchema: GenMessage<GetImagesResponse, {jsonType: GetImagesResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 9);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.InitiateRequest
 */
export type InitiateRequest = Message<"creativefabrica.common.v1.imageprocessor.v1.InitiateRequest"> & {
  /**
   * @generated from field: repeated creativefabrica.common.v1.imageprocessor.v1.BatchUrlRequestItem urls = 1;
   */
  urls: BatchUrlRequestItem[];
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.InitiateRequest
 */
export type InitiateRequestJson = {
  /**
   * @generated from field: repeated creativefabrica.common.v1.imageprocessor.v1.BatchUrlRequestItem urls = 1;
   */
  urls?: BatchUrlRequestItemJson[];
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.InitiateRequest.
 * Use `create(InitiateRequestSchema)` to create a new message.
 */
export const InitiateRequestSchema: GenMessage<InitiateRequest, {jsonType: InitiateRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 10);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.InitiateResponse
 */
export type InitiateResponse = Message<"creativefabrica.common.v1.imageprocessor.v1.InitiateResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.Session session = 1;
   */
  session?: Session | undefined;

  /**
   * @generated from field: repeated creativefabrica.common.v1.imageprocessor.v1.BatchUrlResponseItem urls = 2;
   */
  urls: BatchUrlResponseItem[];
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.InitiateResponse
 */
export type InitiateResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.Session session = 1;
   */
  session?: SessionJson;

  /**
   * @generated from field: repeated creativefabrica.common.v1.imageprocessor.v1.BatchUrlResponseItem urls = 2;
   */
  urls?: BatchUrlResponseItemJson[];
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.InitiateResponse.
 * Use `create(InitiateResponseSchema)` to create a new message.
 */
export const InitiateResponseSchema: GenMessage<InitiateResponse, {jsonType: InitiateResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 11);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.PublishSessionRequest
 */
export type PublishSessionRequest = Message<"creativefabrica.common.v1.imageprocessor.v1.PublishSessionRequest"> & {
  /**
   * @generated from oneof creativefabrica.common.v1.imageprocessor.v1.PublishSessionRequest.ids
   */
  ids: {
    /**
     * @generated from field: string session_id = 1;
     */
    value: string;
    case: "sessionId";
  } | {
    /**
     * @generated from field: creativefabrica.common.v1.imageprocessor.v1.PublishSessionRequest.Images image_ids = 2;
     */
    value: PublishSessionRequest_Images;
    case: "imageIds";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.PublishSessionRequest
 */
export type PublishSessionRequestJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;

  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.PublishSessionRequest.Images image_ids = 2;
   */
  imageIds?: PublishSessionRequest_ImagesJson;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.PublishSessionRequest.
 * Use `create(PublishSessionRequestSchema)` to create a new message.
 */
export const PublishSessionRequestSchema: GenMessage<PublishSessionRequest, {jsonType: PublishSessionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 12);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.PublishSessionRequest.Images
 */
export type PublishSessionRequest_Images = Message<"creativefabrica.common.v1.imageprocessor.v1.PublishSessionRequest.Images"> & {
  /**
   * @generated from field: repeated string image_id = 1;
   */
  imageId: string[];
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.PublishSessionRequest.Images
 */
export type PublishSessionRequest_ImagesJson = {
  /**
   * @generated from field: repeated string image_id = 1;
   */
  imageId?: string[];
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.PublishSessionRequest.Images.
 * Use `create(PublishSessionRequest_ImagesSchema)` to create a new message.
 */
export const PublishSessionRequest_ImagesSchema: GenMessage<PublishSessionRequest_Images, {jsonType: PublishSessionRequest_ImagesJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 12, 0);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.PublishSessionResponse
 */
export type PublishSessionResponse = Message<"creativefabrica.common.v1.imageprocessor.v1.PublishSessionResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.common.v1.imageprocessor.v1.PublishImageResponse images = 1;
   */
  images: PublishImageResponse[];
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.PublishSessionResponse
 */
export type PublishSessionResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.common.v1.imageprocessor.v1.PublishImageResponse images = 1;
   */
  images?: PublishImageResponseJson[];
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.PublishSessionResponse.
 * Use `create(PublishSessionResponseSchema)` to create a new message.
 */
export const PublishSessionResponseSchema: GenMessage<PublishSessionResponse, {jsonType: PublishSessionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 13);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.ListRequest
 */
export type ListRequest = Message<"creativefabrica.common.v1.imageprocessor.v1.ListRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 4;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.ListRequest
 */
export type ListRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 4;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.ListRequest.
 * Use `create(ListRequestSchema)` to create a new message.
 */
export const ListRequestSchema: GenMessage<ListRequest, {jsonType: ListRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 14);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.ListResponse
 */
export type ListResponse = Message<"creativefabrica.common.v1.imageprocessor.v1.ListResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.common.v1.imageprocessor.v1.Session sessions = 1;
   */
  sessions: Session[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.ListResponse
 */
export type ListResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.common.v1.imageprocessor.v1.Session sessions = 1;
   */
  sessions?: SessionJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.ListResponse.
 * Use `create(ListResponseSchema)` to create a new message.
 */
export const ListResponseSchema: GenMessage<ListResponse, {jsonType: ListResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 15);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.GetRequest
 */
export type GetRequest = Message<"creativefabrica.common.v1.imageprocessor.v1.GetRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.GetRequest
 */
export type GetRequestJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.GetRequest.
 * Use `create(GetRequestSchema)` to create a new message.
 */
export const GetRequestSchema: GenMessage<GetRequest, {jsonType: GetRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 16);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.GetResponse
 */
export type GetResponse = Message<"creativefabrica.common.v1.imageprocessor.v1.GetResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.GetResponse
 */
export type GetResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.Session session = 1;
   */
  session?: SessionJson;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.GetResponse.
 * Use `create(GetResponseSchema)` to create a new message.
 */
export const GetResponseSchema: GenMessage<GetResponse, {jsonType: GetResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 17);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadRequest
 */
export type DownloadRequest = Message<"creativefabrica.common.v1.imageprocessor.v1.DownloadRequest"> & {
  /**
   * @generated from oneof creativefabrica.common.v1.imageprocessor.v1.DownloadRequest.download
   */
  download: {
    /**
     * @generated from field: string session_id = 1;
     */
    value: string;
    case: "sessionId";
  } | {
    /**
     * @generated from field: creativefabrica.common.v1.imageprocessor.v1.DownloadRequest.ImageIds image_ids = 2;
     */
    value: DownloadRequest_ImageIds;
    case: "imageIds";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadRequest
 */
export type DownloadRequestJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;

  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.DownloadRequest.ImageIds image_ids = 2;
   */
  imageIds?: DownloadRequest_ImageIdsJson;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.DownloadRequest.
 * Use `create(DownloadRequestSchema)` to create a new message.
 */
export const DownloadRequestSchema: GenMessage<DownloadRequest, {jsonType: DownloadRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 18);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadRequest.ImageIds
 */
export type DownloadRequest_ImageIds = Message<"creativefabrica.common.v1.imageprocessor.v1.DownloadRequest.ImageIds"> & {
  /**
   * @generated from field: repeated string image_ids = 1;
   */
  imageIds: string[];
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadRequest.ImageIds
 */
export type DownloadRequest_ImageIdsJson = {
  /**
   * @generated from field: repeated string image_ids = 1;
   */
  imageIds?: string[];
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.DownloadRequest.ImageIds.
 * Use `create(DownloadRequest_ImageIdsSchema)` to create a new message.
 */
export const DownloadRequest_ImageIdsSchema: GenMessage<DownloadRequest_ImageIds, {jsonType: DownloadRequest_ImageIdsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 18, 0);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadResponse
 */
export type DownloadResponse = Message<"creativefabrica.common.v1.imageprocessor.v1.DownloadResponse"> & {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId: string;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadResponse
 */
export type DownloadResponseJson = {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId?: string;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.DownloadResponse.
 * Use `create(DownloadResponseSchema)` to create a new message.
 */
export const DownloadResponseSchema: GenMessage<DownloadResponse, {jsonType: DownloadResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 19);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.GetDownloadRequest
 */
export type GetDownloadRequest = Message<"creativefabrica.common.v1.imageprocessor.v1.GetDownloadRequest"> & {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId: string;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.GetDownloadRequest
 */
export type GetDownloadRequestJson = {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId?: string;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.GetDownloadRequest.
 * Use `create(GetDownloadRequestSchema)` to create a new message.
 */
export const GetDownloadRequestSchema: GenMessage<GetDownloadRequest, {jsonType: GetDownloadRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 20);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.GetDownloadResponse
 */
export type GetDownloadResponse = Message<"creativefabrica.common.v1.imageprocessor.v1.GetDownloadResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.Download download = 1;
   */
  download?: Download | undefined;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.GetDownloadResponse
 */
export type GetDownloadResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.Download download = 1;
   */
  download?: DownloadJson;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.GetDownloadResponse.
 * Use `create(GetDownloadResponseSchema)` to create a new message.
 */
export const GetDownloadResponseSchema: GenMessage<GetDownloadResponse, {jsonType: GetDownloadResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 21);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.OnProcessingCompletedRequest
 */
export type OnProcessingCompletedRequest = Message<"creativefabrica.common.v1.imageprocessor.v1.OnProcessingCompletedRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string response_url = 2;
   */
  responseUrl: string;

  /**
   * @generated from field: string thumbnail_url = 3;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: string error_message = 4;
   */
  errorMessage: string;

  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.ErrorCode error_code = 5;
   */
  errorCode: ErrorCode;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.OnProcessingCompletedRequest
 */
export type OnProcessingCompletedRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string response_url = 2;
   */
  responseUrl?: string;

  /**
   * @generated from field: string thumbnail_url = 3;
   */
  thumbnailUrl?: string;

  /**
   * @generated from field: string error_message = 4;
   */
  errorMessage?: string;

  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.ErrorCode error_code = 5;
   */
  errorCode?: ErrorCodeJson;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.OnProcessingCompletedRequest.
 * Use `create(OnProcessingCompletedRequestSchema)` to create a new message.
 */
export const OnProcessingCompletedRequestSchema: GenMessage<OnProcessingCompletedRequest, {jsonType: OnProcessingCompletedRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 22);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.OnProcessingCompletedResponse
 */
export type OnProcessingCompletedResponse = Message<"creativefabrica.common.v1.imageprocessor.v1.OnProcessingCompletedResponse"> & {
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.OnProcessingCompletedResponse
 */
export type OnProcessingCompletedResponseJson = {
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.OnProcessingCompletedResponse.
 * Use `create(OnProcessingCompletedResponseSchema)` to create a new message.
 */
export const OnProcessingCompletedResponseSchema: GenMessage<OnProcessingCompletedResponse, {jsonType: OnProcessingCompletedResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 23);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadProcessRequest
 */
export type DownloadProcessRequest = Message<"creativefabrica.common.v1.imageprocessor.v1.DownloadProcessRequest"> & {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId: string;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadProcessRequest
 */
export type DownloadProcessRequestJson = {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId?: string;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.DownloadProcessRequest.
 * Use `create(DownloadProcessRequestSchema)` to create a new message.
 */
export const DownloadProcessRequestSchema: GenMessage<DownloadProcessRequest, {jsonType: DownloadProcessRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 24);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadProcessResponse
 */
export type DownloadProcessResponse = Message<"creativefabrica.common.v1.imageprocessor.v1.DownloadProcessResponse"> & {
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadProcessResponse
 */
export type DownloadProcessResponseJson = {
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.DownloadProcessResponse.
 * Use `create(DownloadProcessResponseSchema)` to create a new message.
 */
export const DownloadProcessResponseSchema: GenMessage<DownloadProcessResponse, {jsonType: DownloadProcessResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 25);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DeleteRequest
 */
export type DeleteRequest = Message<"creativefabrica.common.v1.imageprocessor.v1.DeleteRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DeleteRequest
 */
export type DeleteRequestJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.DeleteRequest.
 * Use `create(DeleteRequestSchema)` to create a new message.
 */
export const DeleteRequestSchema: GenMessage<DeleteRequest, {jsonType: DeleteRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 26);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DeleteResponse
 */
export type DeleteResponse = Message<"creativefabrica.common.v1.imageprocessor.v1.DeleteResponse"> & {
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DeleteResponse
 */
export type DeleteResponseJson = {
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.DeleteResponse.
 * Use `create(DeleteResponseSchema)` to create a new message.
 */
export const DeleteResponseSchema: GenMessage<DeleteResponse, {jsonType: DeleteResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 27);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DeleteAllRequest
 */
export type DeleteAllRequest = Message<"creativefabrica.common.v1.imageprocessor.v1.DeleteAllRequest"> & {
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DeleteAllRequest
 */
export type DeleteAllRequestJson = {
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.DeleteAllRequest.
 * Use `create(DeleteAllRequestSchema)` to create a new message.
 */
export const DeleteAllRequestSchema: GenMessage<DeleteAllRequest, {jsonType: DeleteAllRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 28);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DeleteAllResponse
 */
export type DeleteAllResponse = Message<"creativefabrica.common.v1.imageprocessor.v1.DeleteAllResponse"> & {
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DeleteAllResponse
 */
export type DeleteAllResponseJson = {
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.DeleteAllResponse.
 * Use `create(DeleteAllResponseSchema)` to create a new message.
 */
export const DeleteAllResponseSchema: GenMessage<DeleteAllResponse, {jsonType: DeleteAllResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 29);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.PublishRequest
 */
export type PublishRequest = Message<"creativefabrica.common.v1.imageprocessor.v1.PublishRequest"> & {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId: string;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.PublishRequest
 */
export type PublishRequestJson = {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId?: string;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.PublishRequest.
 * Use `create(PublishRequestSchema)` to create a new message.
 */
export const PublishRequestSchema: GenMessage<PublishRequest, {jsonType: PublishRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 30);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.PublishResponse
 */
export type PublishResponse = Message<"creativefabrica.common.v1.imageprocessor.v1.PublishResponse"> & {
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.PublishResponse
 */
export type PublishResponseJson = {
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.PublishResponse.
 * Use `create(PublishResponseSchema)` to create a new message.
 */
export const PublishResponseSchema: GenMessage<PublishResponse, {jsonType: PublishResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 31);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.OnUploadCompletedRequest
 */
export type OnUploadCompletedRequest = Message<"creativefabrica.common.v1.imageprocessor.v1.OnUploadCompletedRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string upload_id = 2;
   */
  uploadId: string;

  /**
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * @generated from field: string file_name = 5;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 6;
   */
  fileSize: bigint;

  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.UploadStatus status = 4;
   */
  status: UploadStatus;

  /**
   * @generated from field: string error_message = 7;
   */
  errorMessage: string;

  /**
   * @generated from field: string session_id = 8;
   */
  sessionId: string;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.OnUploadCompletedRequest
 */
export type OnUploadCompletedRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string upload_id = 2;
   */
  uploadId?: string;

  /**
   * @generated from field: string url = 3;
   */
  url?: string;

  /**
   * @generated from field: string file_name = 5;
   */
  fileName?: string;

  /**
   * @generated from field: int64 file_size = 6;
   */
  fileSize?: string;

  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.UploadStatus status = 4;
   */
  status?: UploadStatusJson;

  /**
   * @generated from field: string error_message = 7;
   */
  errorMessage?: string;

  /**
   * @generated from field: string session_id = 8;
   */
  sessionId?: string;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.OnUploadCompletedRequest.
 * Use `create(OnUploadCompletedRequestSchema)` to create a new message.
 */
export const OnUploadCompletedRequestSchema: GenMessage<OnUploadCompletedRequest, {jsonType: OnUploadCompletedRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 32);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.OnUploadCompletedResponse
 */
export type OnUploadCompletedResponse = Message<"creativefabrica.common.v1.imageprocessor.v1.OnUploadCompletedResponse"> & {
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.OnUploadCompletedResponse
 */
export type OnUploadCompletedResponseJson = {
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.OnUploadCompletedResponse.
 * Use `create(OnUploadCompletedResponseSchema)` to create a new message.
 */
export const OnUploadCompletedResponseSchema: GenMessage<OnUploadCompletedResponse, {jsonType: OnUploadCompletedResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 33);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.ImageProcessed
 */
export type ImageProcessed = Message<"creativefabrica.common.v1.imageprocessor.v1.ImageProcessed"> & {
  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.Image image = 1;
   */
  image?: Image | undefined;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.ImageProcessed
 */
export type ImageProcessedJson = {
  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.Image image = 1;
   */
  image?: ImageJson;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.ImageProcessed.
 * Use `create(ImageProcessedSchema)` to create a new message.
 */
export const ImageProcessedSchema: GenMessage<ImageProcessed, {jsonType: ImageProcessedJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 34);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.SessionCompleted
 */
export type SessionCompleted = Message<"creativefabrica.common.v1.imageprocessor.v1.SessionCompleted"> & {
  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.SessionCompleted
 */
export type SessionCompletedJson = {
  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.Session session = 1;
   */
  session?: SessionJson;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.SessionCompleted.
 * Use `create(SessionCompletedSchema)` to create a new message.
 */
export const SessionCompletedSchema: GenMessage<SessionCompleted, {jsonType: SessionCompletedJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 35);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadCompleted
 */
export type DownloadCompleted = Message<"creativefabrica.common.v1.imageprocessor.v1.DownloadCompleted"> & {
  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.Download download = 1;
   */
  download?: Download | undefined;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadCompleted
 */
export type DownloadCompletedJson = {
  /**
   * @generated from field: creativefabrica.common.v1.imageprocessor.v1.Download download = 1;
   */
  download?: DownloadJson;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.DownloadCompleted.
 * Use `create(DownloadCompletedSchema)` to create a new message.
 */
export const DownloadCompletedSchema: GenMessage<DownloadCompleted, {jsonType: DownloadCompletedJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 36);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.ImageProcessedEvent
 */
export type ImageProcessedEvent = Message<"creativefabrica.common.v1.imageprocessor.v1.ImageProcessedEvent"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.ImageProcessedEvent
 */
export type ImageProcessedEventJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.ImageProcessedEvent.
 * Use `create(ImageProcessedEventSchema)` to create a new message.
 */
export const ImageProcessedEventSchema: GenMessage<ImageProcessedEvent, {jsonType: ImageProcessedEventJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 37);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.SessionCompletedEvent
 */
export type SessionCompletedEvent = Message<"creativefabrica.common.v1.imageprocessor.v1.SessionCompletedEvent"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.SessionCompletedEvent
 */
export type SessionCompletedEventJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.SessionCompletedEvent.
 * Use `create(SessionCompletedEventSchema)` to create a new message.
 */
export const SessionCompletedEventSchema: GenMessage<SessionCompletedEvent, {jsonType: SessionCompletedEventJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 38);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.SessionsCompletedEvent
 */
export type SessionsCompletedEvent = Message<"creativefabrica.common.v1.imageprocessor.v1.SessionsCompletedEvent"> & {
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.SessionsCompletedEvent
 */
export type SessionsCompletedEventJson = {
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.SessionsCompletedEvent.
 * Use `create(SessionsCompletedEventSchema)` to create a new message.
 */
export const SessionsCompletedEventSchema: GenMessage<SessionsCompletedEvent, {jsonType: SessionsCompletedEventJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 39);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadCompletedEvent
 */
export type DownloadCompletedEvent = Message<"creativefabrica.common.v1.imageprocessor.v1.DownloadCompletedEvent"> & {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId: string;
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadCompletedEvent
 */
export type DownloadCompletedEventJson = {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId?: string;
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.DownloadCompletedEvent.
 * Use `create(DownloadCompletedEventSchema)` to create a new message.
 */
export const DownloadCompletedEventSchema: GenMessage<DownloadCompletedEvent, {jsonType: DownloadCompletedEventJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 40);

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadsCompletedEvent
 */
export type DownloadsCompletedEvent = Message<"creativefabrica.common.v1.imageprocessor.v1.DownloadsCompletedEvent"> & {
};

/**
 * @generated from message creativefabrica.common.v1.imageprocessor.v1.DownloadsCompletedEvent
 */
export type DownloadsCompletedEventJson = {
};

/**
 * Describes the message creativefabrica.common.v1.imageprocessor.v1.DownloadsCompletedEvent.
 * Use `create(DownloadsCompletedEventSchema)` to create a new message.
 */
export const DownloadsCompletedEventSchema: GenMessage<DownloadsCompletedEvent, {jsonType: DownloadsCompletedEventJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 41);

/**
 * @generated from enum creativefabrica.common.v1.imageprocessor.v1.ImageStatus
 */
export enum ImageStatus {
  /**
   * @generated from enum value: IMAGE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: IMAGE_STATUS_UPLOADED = 1;
   */
  UPLOADED = 1,

  /**
   * @generated from enum value: IMAGE_STATUS_REQUESTED = 2;
   */
  REQUESTED = 2,

  /**
   * @generated from enum value: IMAGE_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: IMAGE_STATUS_ERROR = 4;
   */
  ERROR = 4,
}

/**
 * @generated from enum creativefabrica.common.v1.imageprocessor.v1.ImageStatus
 */
export type ImageStatusJson = "IMAGE_STATUS_UNSPECIFIED" | "IMAGE_STATUS_UPLOADED" | "IMAGE_STATUS_REQUESTED" | "IMAGE_STATUS_COMPLETED" | "IMAGE_STATUS_ERROR";

/**
 * Describes the enum creativefabrica.common.v1.imageprocessor.v1.ImageStatus.
 */
export const ImageStatusSchema: GenEnum<ImageStatus, ImageStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 0);

/**
 * @generated from enum creativefabrica.common.v1.imageprocessor.v1.DownloadStatus
 */
export enum DownloadStatus {
  /**
   * @generated from enum value: DOWNLOAD_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DOWNLOAD_STATUS_REQUESTED = 1;
   */
  REQUESTED = 1,

  /**
   * @generated from enum value: DOWNLOAD_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * @generated from enum value: DOWNLOAD_STATUS_ERROR = 3;
   */
  ERROR = 3,
}

/**
 * @generated from enum creativefabrica.common.v1.imageprocessor.v1.DownloadStatus
 */
export type DownloadStatusJson = "DOWNLOAD_STATUS_UNSPECIFIED" | "DOWNLOAD_STATUS_REQUESTED" | "DOWNLOAD_STATUS_COMPLETED" | "DOWNLOAD_STATUS_ERROR";

/**
 * Describes the enum creativefabrica.common.v1.imageprocessor.v1.DownloadStatus.
 */
export const DownloadStatusSchema: GenEnum<DownloadStatus, DownloadStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 1);

/**
 * @generated from enum creativefabrica.common.v1.imageprocessor.v1.SessionStatus
 */
export enum SessionStatus {
  /**
   * @generated from enum value: SESSION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SESSION_STATUS_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: SESSION_STATUS_REQUESTED = 2;
   */
  REQUESTED = 2,

  /**
   * @generated from enum value: SESSION_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: SESSION_STATUS_FAILED = 4;
   */
  FAILED = 4,
}

/**
 * @generated from enum creativefabrica.common.v1.imageprocessor.v1.SessionStatus
 */
export type SessionStatusJson = "SESSION_STATUS_UNSPECIFIED" | "SESSION_STATUS_CREATED" | "SESSION_STATUS_REQUESTED" | "SESSION_STATUS_COMPLETED" | "SESSION_STATUS_FAILED";

/**
 * Describes the enum creativefabrica.common.v1.imageprocessor.v1.SessionStatus.
 */
export const SessionStatusSchema: GenEnum<SessionStatus, SessionStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 2);

/**
 * @generated from enum creativefabrica.common.v1.imageprocessor.v1.UploadStatus
 */
export enum UploadStatus {
  /**
   * @generated from enum value: UPLOAD_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPLOAD_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: UPLOAD_STATUS_SUCCESS = 2;
   */
  SUCCESS = 2,

  /**
   * @generated from enum value: UPLOAD_STATUS_ERROR = 3;
   */
  ERROR = 3,
}

/**
 * @generated from enum creativefabrica.common.v1.imageprocessor.v1.UploadStatus
 */
export type UploadStatusJson = "UPLOAD_STATUS_UNSPECIFIED" | "UPLOAD_STATUS_PENDING" | "UPLOAD_STATUS_SUCCESS" | "UPLOAD_STATUS_ERROR";

/**
 * Describes the enum creativefabrica.common.v1.imageprocessor.v1.UploadStatus.
 */
export const UploadStatusSchema: GenEnum<UploadStatus, UploadStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 3);

/**
 * @generated from enum creativefabrica.common.v1.imageprocessor.v1.ErrorCode
 */
export enum ErrorCode {
  /**
   * @generated from enum value: ERROR_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ERROR_CODE_TIMEOUT = 1;
   */
  TIMEOUT = 1,

  /**
   * @generated from enum value: ERROR_CODE_SAI_ERROR = 2;
   */
  SAI_ERROR = 2,

  /**
   * @generated from enum value: ERROR_CODE_INTERNAL_SERVER_ERROR = 3;
   */
  INTERNAL_SERVER_ERROR = 3,

  /**
   * @generated from enum value: ERROR_CODE_UPLOAD_EXPIRED = 4;
   */
  UPLOAD_EXPIRED = 4,
}

/**
 * @generated from enum creativefabrica.common.v1.imageprocessor.v1.ErrorCode
 */
export type ErrorCodeJson = "ERROR_CODE_UNSPECIFIED" | "ERROR_CODE_TIMEOUT" | "ERROR_CODE_SAI_ERROR" | "ERROR_CODE_INTERNAL_SERVER_ERROR" | "ERROR_CODE_UPLOAD_EXPIRED";

/**
 * Describes the enum creativefabrica.common.v1.imageprocessor.v1.ErrorCode.
 */
export const ErrorCodeSchema: GenEnum<ErrorCode, ErrorCodeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_common_v1_imageprocessor_v1_types, 4);

